import { LicensePackageTypes, LicenseStatusTypes } from '../../domain/license';
import { BillingCycleTypes } from '../../domain/invoice';
import { AddOnPricingDetailArray } from '@models/domain/add.on.pricing.detail';

export interface ILicenseEditRequest {
    ID: number;
    Status: LicenseStatusTypes;
    PackageType: LicensePackageTypes;
    ProductID: number;
    TransferDisabled: boolean;
    TransferDisabledReason: string;
    TransferLimitMax: number;
    TransferLimitInTimeMinutes: number;
    SoftwareVersionLock: string;
    SoftwareVersionLockReason: string;
    NextBillingDate: Date;
    ProductRecurringAmount: number;
    YardRecurringAmount: number;
    StatusDisabledReason: string;
    PoolStudioSettingsGroup: number;
    BillingCycle: BillingCycleTypes;
    SalesRepresentativeID: number;
    DontSendManualCancellationEmail: boolean;
    AlwaysImportStatistics: boolean;
    CancellationReason: string;
    TerminationDate: Date;
    Note: string;
    OverrideUpdaterClientSettings_ID: number;
    TOSDetectiveWhiteListExpiration: Date;
    UpdateVersionForceGroupID?: number;
    UpdaterV3VersionForceGroupID?: number;
    PreventV3Install: boolean;
    TransferLimitPCs?: number;
    IgnoreHardwareCheck: boolean;
    TOSWindow: boolean;
    TOSWindowContinueUntilDate: Date;
    AddOnPricingDetails: AddOnPricingDetailArray;
}

export class LicenseEditRequest implements ILicenseEditRequest {
    ID: number;
    Status: LicenseStatusTypes;
    PackageType: LicensePackageTypes;
    ProductID: number;
    TransferDisabled: boolean;
    TransferDisabledReason: string;
    TransferLimitMax: number;
    TransferLimitInTimeMinutes: number;
    SoftwareVersionLock: string;
    SoftwareVersionLockReason: string;
    NextBillingDate: Date;
    ProductRecurringAmount: number;
    YardRecurringAmount: number;
    StatusDisabledReason: string;
    PoolStudioSettingsGroup: number;
    BillingCycle: BillingCycleTypes;
    SalesRepresentativeID: number;
    DontSendManualCancellationEmail: boolean;
    AlwaysImportStatistics: boolean;
    CancellationReason: string;
    TerminationDate: Date;
    Note: string;
    OverrideUpdaterClientSettings_ID: number;
    TOSDetectiveWhiteListExpiration: Date;
    UpdateVersionForceGroupID?: number;
    UpdaterV3VersionForceGroupID?: number;
    PreventV3Install: boolean;
    TransferLimitPCs?: number;
    IgnoreHardwareCheck: boolean;
    TOSWindow: boolean;
    TOSWindowContinueUntilDate: Date;
    AddOnPricingDetails: AddOnPricingDetailArray;
}
